import script from "./LocationOverview.vue?vue&type=script&setup=true&lang=ts"
export * from "./LocationOverview.vue?vue&type=script&setup=true&lang=ts"

import "./LocationOverview.vue?vue&type=style&index=0&id=02a69721&scoped=true&lang=scss"

import exportComponent from "/Users/joris/Documents/website/film-point-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02a69721"]])

export default __exports__